import { ASSIGNMENT_STATUS, ENTITY_TYPE } from "./constants";
import { getDistrictAssignments } from "./getAssignment/getAssignment";
import { updateBatchAssignments } from "./updateBatchAssignments";
import { getDefaultTemplates } from "./getAssignmentTemplate";
import { addAssignment } from "./addAssignment/addAssignment";
import { cleanManifest, insertLetterNamingAndSounds, removeLetterNamingAndSounds } from "./manifest";

export async function getDistrictWindow(districtId){

  let assignments = await getDistrictAssignments(districtId);
  return assignments.filter(assignment=>assignment.status === ASSIGNMENT_STATUS.ASSIGNED);
}

export async function unassignAllDistrictAssignments(districtId){
  let assignments = await getDistrictWindow(districtId);
  if(assignments.length){
    const assignmentIds = assignments.map((assignment)=>assignment.assignmentId);
    if(assignmentIds.length){
      let batchInput = assignmentIds.map((id)=>{
        return {
          entityId: districtId,
          entityType: ENTITY_TYPE.DISTRICT,
          assignmentId: id,
          status: ASSIGNMENT_STATUS.UNASSIGNED
        }
      });
      await updateBatchAssignments(batchInput);
    }
  }
}

export async function updateDistrictScreeningWindow(districtId,dateStart,dateEnd,licenseData){
  const requestResults = await Promise.all([unassignAllDistrictAssignments(districtId),getDefaultTemplates(districtId)]);

  let placeholderTemplate = requestResults[1][3];
  placeholderTemplate.manifest = cleanManifest(placeholderTemplate.manifest);

  // if the licenseData has letterNamingAndSoundsConfig, and it has at least one config that is true, then we insert the letterNamingAndSounds activity
  if(licenseData?.letterNamingAndSoundsConfig?.length && licenseData.letterNamingAndSoundsConfig.some((config)=>config)){
    placeholderTemplate.manifest = insertLetterNamingAndSounds(placeholderTemplate.manifest);
  }else if(licenseData?.letterNamingAndSoundsConfig?.length && !licenseData.letterNamingAndSoundsConfig.some((config)=>config)){
    placeholderTemplate.manifest = removeLetterNamingAndSounds(placeholderTemplate.manifest);
  }

  let assignment = {
    assignmentType: "BENCHMARK",
    dateFrom: dateStart,
    dateTo: dateEnd,
    entityId: districtId,
    entityType: ENTITY_TYPE.DISTRICT,
    manifest: placeholderTemplate.manifest,
    status: ASSIGNMENT_STATUS.ASSIGNED
  }
  let resp = await addAssignment(assignment);
  resp.numberOfChanges = Array.isArray(requestResults) ? requestResults.length : 1;
  return resp;
}